import { DownOutlined, UpOutlined } from "@ant-design/icons";
import {
  Col,
  Collapse,
  DatePicker,
  Form,
  Input,
  notification,
  Radio,
  Row,
} from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import classes from "./EtapeDonneesGenerales.module.css";
import { useEffect } from "react";
import { generate_numero_groupe } from "../../../../../api/geoprod";
const { Panel } = Collapse;

const EtapeDonneesGenerales = ({
  form,
  id_session_formation_homologuee,
  setIsLoading,
  id_affaire,
  id_formation,
  registration_number,
}) => {
  const { t } = useTranslation();

  // useEffect(() => {
  //   // debugger;
  //   if(!id_session_formation_homologuee && !form.getFieldsValue()["num_grp"] && !JSON.parse(sessionStorage?.getItem("globalData"))?.num_grp)
  //   {    generate_numero_groupe({
  //     id_affaire: sessionStorage.getItem("id_session_formation_homologuee"),
  //     id_formation: id_formation?.toString(),
  //     registration_number: registration_number,
  //   })
  //     .then((responseAddNotes) => {
  //       form.setFieldsValue({
  //         ...form.getFieldsValue(),
  //         num_grp: responseAddNotes?.message,
  //       });
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       notification?.error({
  //         message: t("Erreur"),
  //         description: t(error?.data?.message),
  //         duration: 0,
  //       });
  //       setIsLoading(false);
  //     });

  //   }

  // }, []);

  const expandIcon = ({ isActive }) =>
    isActive ? <UpOutlined /> : <DownOutlined />;

  return (
    <div>
      <Collapse
        bordered={false}
        defaultActiveKey={["1"]}
        expandIcon={expandIcon}
        expandIconPosition="end"
        className={classes.container}
      >
        <Panel
          header={
            <div className={classes.headerStyle}>
              <span>
                Informations par défaut de la session
                <span style={{ marginLeft: "0.5rem" }}></span>
              </span>
            </div>
          }
          key="1"
        >
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item label={t("Secteur")} name="secteur">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label={t("Sous-secteur")} name="sous_secteur">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label={t("Spécialité")} name="specialite">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Niveau minimal exigé pour la participation")}
                name="niveau_requis"
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Diplôme délivrée à la fin de la session")}
                name="diplome"
              >
                <Input disabled />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={12}>
              <Form.Item
                label={t("Date d’expiration de l’homologation de la spécialité")}
                name="date_fin_homologation"
              >
                <DatePicker
                  disabled
                  format="DD/MM/YYYY"
                  placeholder="JJ/MM/AAAA"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col> */}
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Capacité générale (en personnes)")}
                name="capacite_generale"
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label={t("Numéro du groupe")} name="num_grp">
                <Input disabled />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={12}>
              <Form.Item
                label={t("Type de période")}
                name="type_periode"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label={`Nombre de période`}
                name="nombre_periode"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <Input disabled />
              </Form.Item>
            </Col> */}
          </Row>
        </Panel>
      </Collapse>

      <Collapse
        bordered={false}
        defaultActiveKey={["1"]}
        expandIcon={expandIcon}
        expandIconPosition="end"
        className={classes.container}
      >
        <Panel
          header={
            <div className={classes.headerStyle}>
              <span>
                Données à configurer pour la session
                <span style={{ marginLeft: "0.5rem" }}></span>
              </span>
            </div>
          }
          key="1"
        >
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Date de début de la session de formation")}
                name="date_debut_session_formation"
                rules={[
                  { required: true, message: t("Veuillez remplir ce champ.") },
                ]}
              >
                <DatePicker
                  disabled={id_session_formation_homologuee && sessionStorage.getItem("consulter") === "true"}
                  format="DD/MM/YYYY"
                  placeholder="JJ/MM/AAAA"
                  style={{ width: "100%" }}
                  // disabledDate={(current) =>
                  //   current && current < dayjs().add(1, "month").startOf("day")
                  // }
                  disabledDate={(current) => current && current < dayjs().endOf("day")}
                  
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label={t(
                  "Cette session de formation est-elle concernée par le Chèque Formation ?"
                )}
                name="cheque_formation"
                rules={[
                  { required: true, message: t("Veuillez remplir ce champ.") },
                ]}
              >
                <Radio.Group disabled={id_session_formation_homologuee && sessionStorage.getItem("consulter") === "true"}>
                  <Radio value="Oui">{t("Oui")}</Radio>
                  <Radio value="Non">{t("Non")}</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Panel>
      </Collapse>
    </div>
  );
};

export default EtapeDonneesGenerales;
